"use client";

import { motion } from "framer-motion";
import { useLang } from "@/contexts/language-context";

const STEPS = [
  { label: { en: "Deposit collected · recorded at booking", es: "Depósito cobrado · registrado al reservar" }, amount: "$500", sign: "", tone: "savings" },
  { label: { en: "Table minimum", es: "Mínimo de la mesa" }, amount: "$2,000", sign: "", tone: "neutral" },
  { label: { en: "Tab during the night", es: "Tab durante la noche" }, amount: "$2,840", sign: "", tone: "neutral" },
  { label: { en: "Minimum met · ready to close", es: "Mínimo cumplido · lista para cerrar" }, amount: "$2,840", sign: "=", tone: "final" },
];

export default function VipTableMapDepositMath() {
  const { t } = useLang();

  return (
    <section className="relative py-32 px-6 bg-[#0F0B1F] text-white overflow-hidden">
      <div className="relative max-w-[1080px] mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16 max-w-[760px] mx-auto"
        >
          <div className="text-[11px] font-black tracking-widest uppercase mb-4" style={{ color: "#F472B6" }}>
            {t("Deposit tracking", "Registro de depósitos")}
          </div>
          <h2 className="text-4xl md:text-[64px] font-black tracking-[-0.03em] leading-[1.02]">
            {t("Deposits ", "Los depósitos ")}
            <span className="text-white/30">{t("on the record.", "quedan registrados.")}</span>
          </h2>
          <p className="text-[16px] font-medium text-white/55 leading-relaxed mt-6">
            {t(
              "Collect the deposit your way when the table is booked, then record it in Redy. It stays on the table next to its minimum, so at 2 AM the host and the supervisor know what was already paid and how close the table is to its minimum.",
              "Cobras el depósito como prefieras al reservar la mesa y lo registras en Redy. Queda en la mesa junto a su mínimo, así a las 2 AM el host y el supervisor saben qué ya se pagó y cuánto le falta a la mesa para su mínimo."
            )}
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, scale: 0.96 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.8, ease: [0.21, 0.47, 0.32, 0.98] }}
          className="bg-white/[0.04] backdrop-blur-xl border border-white/10 rounded-[28px] p-8 md:p-10 max-w-[720px] mx-auto"
        >
          <div className="text-[10px] font-black tracking-widest uppercase text-white/45 mb-2">
            {t("VIP-3 · Saturday Dec 14", "VIP-3 · Sábado Dic 14")}
          </div>
          <div className="text-[20px] font-black text-white mb-8">
            {t("Carlos Reyes · party of 6", "Carlos Reyes · grupo de 6")}
          </div>

          <div className="space-y-3" style={{ fontFamily: "ui-monospace, SFMono-Regular, Menlo, monospace" }}>
            {STEPS.map((s, i) => {
              const isSavings = s.tone === "savings";
              const isFinal = s.tone === "final";
              return (
                <motion.div
                  key={s.label.en}
                  initial={{ opacity: 0, x: -16 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true, margin: "-80px" }}
                  transition={{ duration: 0.5, delay: 0.2 + 0.15 * i }}
                  className={`flex items-baseline justify-between ${
                    isFinal ? "pt-4 border-t border-dashed border-white/20" : ""
                  } ${isSavings ? "rounded-[10px] px-3 py-2" : ""}`}
                  style={
                    isSavings
                      ? { backgroundColor: "rgba(244,114,182,0.10)" }
                      : undefined
                  }
                >
                  <div
                    className={`text-[13px] ${
                      isFinal ? "font-black text-white" : "text-white/65"
                    }`}
                    style={isSavings ? { color: "#F472B6", fontWeight: 700 } : undefined}
                  >
                    {t(s.label.en, s.label.es)}
                  </div>
                  <div
                    className={`text-[15px] font-black tabular-nums ${
                      isFinal ? "" : ""
                    }`}
                    style={{
                      color: isSavings
                        ? "#F472B6"
                        : isFinal
                          ? "#C4B5FD"
                          : "white",
                      fontSize: isFinal ? "32px" : undefined,
                      lineHeight: isFinal ? "1" : undefined,
                    }}
                  >
                    {s.sign === "=" ? "" : s.sign}
                    {s.amount}
                  </div>
                </motion.div>
              );
            })}
          </div>

          <motion.div
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.6, delay: 1.0 }}
            className="mt-8 text-center text-[12px] font-medium text-white/45"
          >
            {t(
              "No spreadsheet. No \"wait, did they pay a deposit?\" It's on the table's record.",
              "Sin spreadsheet. Sin \"¿pagaron depósito?\". Queda en el registro de la mesa."
            )}
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
}
